import mapObjIndexed from "ramda/es/mapObjIndexed";
import { fieldType } from '../../validations/constants';
export const enhanceFormDescriptor = mapObjIndexed((record, key)=>({
        ...record,
        fieldName: key,
        type: record.type || fieldType.FIELD
    }));
